import { useEffect, useMemo } from 'react';

import useGetPageVisible from './useGetPageVisible';

interface Props {
  isMobile: boolean;
  handleVisibleState: () => void;
  handleInvisibleState: () => void;
}

const usePageInOutIntervalRequest = ({
  isMobile,
  handleInvisibleState,
  handleVisibleState,
}: Props) => {
  const { isDocVisible, isMouseIn } = useGetPageVisible();

  const isVisible = useMemo(
    () => (isMobile ? isDocVisible : isDocVisible && isMouseIn),
    [isMobile, isDocVisible, isMouseIn],
  );

  useEffect(() => {
    if (isVisible) {
      handleVisibleState();
    }
    if (!isVisible) {
      handleInvisibleState();
    }
  }, [isVisible]);
};

export default usePageInOutIntervalRequest;
